/**
 * Merge message.acknowledges from Redux entity + modal payload by user id.
 * Chat-cached lastMessage rows may carry stale/unsigned URLs; the modal payload
 * (chat open or People history) is signed at request time and wins when present.
 * Later (modal) URLs also replace an intermediate oneForAll signer-N URL after
 * the payload was remapped to final.pdf.
 */
export default function mergeAcknowledgesForReadModal(fromEntity, fromModal) {
  const map = new Map();
  for (const list of [fromEntity, fromModal]) {
    if (!Array.isArray(list) || !list.length) continue;
    for (const raw of list) {
      if (raw == null || raw.user == null) continue;
      const k = String(raw.user);
      const prev = map.get(k);
      if (!prev) {
        map.set(k, { ...raw });
      } else {
        map.set(k, {
          ...prev,
          ...raw,
          signedDocUrl: raw.signedDocUrl || prev.signedDocUrl,
          logUrl: raw.logUrl || prev.logUrl,
          confirmedAt: prev.confirmedAt ?? raw.confirmedAt,
        });
      }
    }
  }
  if (map.size) return [...map.values()];
  if (Array.isArray(fromEntity) && fromEntity.length) return fromEntity;
  if (Array.isArray(fromModal)) return fromModal;
  return [];
}

const definedFields = obj =>
  Object.fromEntries(Object.entries(obj).filter(([, value]) => value !== undefined));

/**
 * Prefer the modal payload (freshly signed history/chat open) over a cached entity
 * so People-tab opens are not overwritten by an unsigned channel lastMessage.
 */
export function mergeMessageForReadModal(modalMsg, entity) {
  if (!entity || !modalMsg) return modalMsg;
  return {
    ...entity,
    ...definedFields(modalMsg),
    acknowledges: mergeAcknowledgesForReadModal(entity.acknowledges, modalMsg.acknowledges),
  };
}
